/**
 * @file /study 配下の間だけ body の背景をスタディの薄い青にする。
 * @why: スタディ面は本体 (Soft Sage) と切り替わったことが分かる青基調にする
 *   (代表 2026-08-20)。Layout は body の背景を透過しているので body 側で切り替える。
 * @failure: unmount で必ず戻す (エクスポート等の既存画面に青を漏らさない)。
 */

import { useEffect } from "react";

export function useStudyBackground(): void {
  useEffect(() => {
    document.body.classList.add("study-bg");
    return () => document.body.classList.remove("study-bg");
  }, []);
}
